/** IANA timezone helpers for streak + dashboard week windows. */

export function sanitizeTimeZone(timeZone: string | null | undefined): string {
  const candidate = timeZone?.trim();
  if (!candidate) return "UTC";
  try {
    Intl.DateTimeFormat(undefined, { timeZone: candidate });
    return candidate;
  } catch {
    return "UTC";
  }
}

export function getClientTimeZone(): string {
  try {
    return sanitizeTimeZone(
      Intl.DateTimeFormat().resolvedOptions().timeZone,
    );
  } catch {
    return "UTC";
  }
}

/** `YYYY-MM-DD` in the given IANA timezone. */
export function localCalendarDateKey(
  date: Date,
  timeZone: string,
): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

export function addDaysToDateKey(key: string, deltaDays: number): string {
  const [y, m, d] = key.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + deltaDays);
  return dt.toISOString().slice(0, 10);
}

/** Inclusive rolling 7-day window in the user's local calendar. */
export function getRollingSevenDayStartKey(
  timeZone: string,
  now = new Date(),
): string {
  const today = localCalendarDateKey(now, timeZone);
  return addDaysToDateKey(today, -6);
}

export function isLocalDateOnOrAfter(
  isoTimestamp: string,
  startKey: string,
  timeZone: string,
): boolean {
  return localCalendarDateKey(new Date(isoTimestamp), timeZone) >= startKey;
}
